module.exports = __webpack_public_path__ + "img/placeholder.d3f03c8b.jpg";